'use client'

import { ImportWizard } from './import-wizard'

interface ImportDataButtonProps {
  disabled?: boolean
}

export function ImportDataButton({ disabled }: ImportDataButtonProps) {
  if (disabled) return null
  return <ImportWizard />
}
